module.exports = __webpack_public_path__ + "img/制御工学3_6_3.7bc0102f.png";